<template>
  <div :class="['loader__container', { '--form': form, '--share': share }]">
    <div class="loader" />
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    form: {
      type: Boolean,
      default: false,
    },
    share: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
